import dateFns from 'date-fns';

function formatInvoice(code) {
  const c = typeof code === 'string' ? code : code.toString();
  return `${c[0]}${c[1]}-${c[2]}${c[3]}-${c[4]}${c[5]}-${c[6]}${c[7]}-${c[8]}${c[9]}-${c[10]}${c[11]}-${c[12]}${c[13]}`;
}

function formatISO8601(iso8601) {
  const date = new Date(iso8601);

  if (!dateFns.isDate(date)) {
    throw new Error('invalid format of ISO8601');
  }

  if (dateFns.isToday(date)) {
    return dateFns.format(date, 'HH:mm:ss');
  }

  return dateFns.format(date, 'DD-MM-YY HH:mm:ss');
}

function formatUnixTimestamp(timestamp) {
  if (Number.isNaN(timestamp)) {
    throw new Error('invalid type of timestamp, expected a number');
  }

  const date = new Date(timestamp);

  if (dateFns.isToday(date)) {
    return dateFns.format(date, 'HH:mm:ss');
  }

  return dateFns.format(date, 'DD-MM-YY HH:mm:ss');
}

function convertSystemToCurrency(amount, currency = 'UAH') {
  if (Number.isNaN(amount)) {
    throw new Error('invalid type of amount, expected a number');
  }

  switch (currency) {
    case 'UAH':
      return (amount / 100).toFixed(2);
    case 'PLN':
      return (amount / 100).toFixed(2);
    case 'FUN':
      return (amount / 100).toFixed(2);
    default:
      throw new Error(`no such currency ${currency}`);
  }
}

function convertCurrencyToSystem(amount, currency = 'UAH') {
  if (Number.isNaN(amount)) {
    throw new Error('invalid type of amount, expected a number');
  }

  switch (currency) {
    case 'UAH':
      return Math.floor(amount * 100);
    case 'PLN':
      return Math.floor(amount * 100);
    case 'FUN':
      return Math.floor(amount * 100);
    default:
      throw new Error(`no such currency ${currency}`);
  }
}

export default {
  formatInvoice,
  formatISO8601,
  formatUnixTimestamp,
  convertSystemToCurrency,
  convertCurrencyToSystem,
};
